import { BASE_API_URL } from './api'

// 是否开启AI流式回复
export const STREAM_REPLY = false

export const ChatFeedbackDialogueOptions = [
  'Out of Character',
  'Bad Memory',
  'Too Short',
  'Too Slow',
  'Boring',
  'Illogical',
  "Don't like the style",
  'Repetitive',
  'Too Long',
  'Empty Response',
  'Ended Chat Early',
  'Respond as User',
  'Random code',
  'Irrelevant content',
  'Wrong Language',
  'Too mushy',
]

export const ChatFeedbackVoiceOptions = [
  'Noise, or distorted sound',
  'Sounds robotic or unnatural',
  "Does not resemble the original character's voice",
  'Insufficient emotional expression',
  'Too difficult to understand',
]

export const ChatFeedbackMediaOptions = [
  'Character inconsistency',
  'Unrealistic content',
  'Style mismatch',
  "Doesn't match the plot",
  'Stiff expression',
  'Awkward pose',
  'Blurry image',
  'Lacks detail',
  'Repetitive',
  'Too slow',
]

// 聊天会话消息最大长度
export const DEFAULT_CHAT_MSG_LEN = 60
// 聊天反馈描述最大长度
export const DEFAULT_CHAT_FEEDBACK_DESC_LEN = 200

export const USER_CHATTED_LIST_LIMIT = 20

/**
 * Chat Archives（聊天存档整合）功能上线时间戳（毫秒）。
 * 上线引导仅对「上线前注册的老用户」展示，且有效窗口为上线后 14 天。
 * 上线时间：北京时间 2026-07-11 00:00（UTC 2026-07-10T16:00:00Z）；后端如下发上线时间则改用后端值。
 */
export const CHAT_ARCHIVES_FEATURE_LAUNCH_TS = new Date(
  '2026-07-10T16:00:00Z'
).getTime()
/** 上线引导有效窗口：14 天（毫秒） */
export const CHAT_ARCHIVES_GUIDE_WINDOW_MS = 14 * 24 * 60 * 60 * 1000

export const chatUrls = [
  `${BASE_API_URL}/chat/send_msg`,
  `${BASE_API_URL}/chat/send_msg_stream`,
  `${BASE_API_URL}/chat/story/send_msg`,
  `${BASE_API_URL}/chat/retell`,
  `${BASE_API_URL}/chat/retell_stream`,
  `${BASE_API_URL}/chat/story/retell`,
  `${BASE_API_URL}/chat/continue_reply`,
  `${BASE_API_URL}/chat/continue_reply_stream`,
  `${BASE_API_URL}/chat/reply_msg`,
  `${BASE_API_URL}/chat/reply_msg_stream`,
  `${BASE_API_URL}/chat/story/reply_msg`,
  `${BASE_API_URL}/chat/media/image`,
  `${BASE_API_URL}/chat/media/video`,
]

export const roleCardUrls = [
  `${BASE_API_URL}/character_memory/add_user_profile`,
  `${BASE_API_URL}/user/profile_card/set`,
]

/** i18n 文案键：记忆上限引导（桌面聊天栏 + 移动端模型按钮共用） */
export const MEMORY_LIMIT_GUIDE_TEXT =
  "The character's memory is full. They might forget earlier details as you continue to chat. To prevent this, you can expand their memory in the Memory & Model settings.\nNote: Using more memory increases the gem cost per message."
